// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DislikeOutlinedSvg from "@fishx/icons-svg/es/asn/DislikeOutlined";
import FishxIcon from '../components/FishxIcon';

var DislikeOutlined = function DislikeOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DislikeOutlinedSvg
  }));
};

DislikeOutlined.displayName = 'DislikeOutlined';
export default React.forwardRef(DislikeOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DislikeOutlined.js
// module id = 2434
// module chunks = 0